exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common_form_search[data-v-380b15f1]{padding:15px 15px 0 15px;background-color:#ffffff;border-radius:0 0 10px 10px}.child_page[data-v-380b15f1]{padding:15px}\n", ""]);

// exports
